import { LoginPage } from '@/components/log-in';
import { createFileRoute, redirect } from '@tanstack/react-router';
import * as v from 'valibot';

export const Route = createFileRoute('/log-in')({
  validateSearch: v.object({
    redirect: v.optional(v.string()),
  }),
  beforeLoad: async ({ context, search }) => {
    if (context.user) {
      throw redirect({ to: search.redirect || '/' });
    }
  },
  component: LoginPage,
});
